module.exports = __webpack_public_path__ + "img/class6.c3d3c3c6.png";